import { useParams, useWallet, useFm } from '@web3/base-hooks';
import { Button } from '@bfe/moly';
import { appPath } from '@web3/base-utils';
import SparkleIcon from '@/assets/svg/activity/sparkle.svg';
import { DirectionrightIcon } from '@bfe/moly-icons';
import { scTrack, WEB3_EVENT } from '@web3/base-tracking';

import styles from './index.module.scss';

interface Props {
  chainId: number;
  eligibilityCount: number;
}

export const ClaimCard = (props: Props) => {
  const { chainId, eligibilityCount } = props;
  const { locale } = useParams();
  const { mixedChainMap } = useWallet();
  const fm = useFm();

  return (
    <div className={styles.container}>
      <div className={styles.main}>
        <img
          className={styles.avatar}
          src={mixedChainMap[chainId].iconNightUrl}
        />
        <div className={styles.content}>
          <div className={styles.title}>
            {fm('airdropsToClaim', {
              num: <span className={styles.reward}>{eligibilityCount}</span>,
            })}
          </div>
          <div className={styles.desc}>
            {fm('quickClaimToAvoidInvalidation')}
          </div>
        </div>
      </div>
      <Button
        className={styles.button}
        variant="primary"
        onClick={() => {
          scTrack(WEB3_EVENT.Web3UserClick, {
            page_name: 'AirdropArcade_DetailPage',
            button_name: 'ClaimRewards',
          });
          window.open(`/${locale}${appPath}/rewards`, '_blank');
        }}
      >
        {fm('claimNow')}
        <DirectionrightIcon className={styles.arrow} />
      </Button>
      <SparkleIcon className={styles.sparkIcon1} />
      <SparkleIcon className={styles.sparkIcon2} />
    </div>
  );
};
